import { render, staticRenderFns } from "./yinSi.vue?vue&type=template&id=40c86450&scoped=true&"
import script from "./yinSi.vue?vue&type=script&lang=js&"
export * from "./yinSi.vue?vue&type=script&lang=js&"
import style0 from "./yinSi.vue?vue&type=style&index=0&id=40c86450&lang=scss&scoped=true&"
import style1 from "./yinSi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c86450",
  null
  
)

export default component.exports